module.exports = __webpack_public_path__ + "static/media/region-ico.eb92227e.svg";